import { Box } from "@mui/material";

export default function StepHeader({ children }) {
    return (
        <Box
            component="h1"
            sx={{
                fontFamily: "'Black Ops One', serif",
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 400,
                letterSpacing: "0.03em",
                color: "text.primary",
                lineHeight: 1.1,
                margin: 0,
            }}
        >
            {children}
        </Box>
    );
}
